import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../config/axios";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import RailwaysProject from "./RailwayProjects";
import AddRailwayProject from "./AddRailwayProject";
import RailwaySections from "./RailwaySections";
import { AddProjectDetails } from "../ProjectDetailsCrud/ProjectDetailsCRUD";
import ProjectFilter from "../Projectname/ProjectFilter";
import SectionFilter from "../ProjectDetailsCrud/SectionFilter";

const RailwayPage = () => {

    const [toggleState, setToggleState] = useState(1);
    const [buffer, setBuffering] = useState(false);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Railways Project Details";
            case 2: return "Railways Section Details";
            default: return "Project";
        }
    };

    const [projectName, setProjectName] = useState([]);

    const getProjectname = async (filters = null) => {
        setBuffering(true);
        try {
            let res;
            if (filters) {
                const url = `${BASE_URL}/dpr/projectdetailsmultiplefilter/${filters.project || "null"}/${filters.sector || "null"}/${filters.workType || "null"}/${filters.companyName || "null"}/${filters.loaStartDate || "null"}/${filters.loaEndDate || "null"}/${filters.completionStartDate || "null"}/${filters.completionEndDate || "null"}/`;
                res = await axios.get(url);
            } else {
                res = await axios.get(`${BASE_URL}/dpr/projectdetailsfiltersector/a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7/`);
            }
            setProjectName(res.data);
        } catch (err) {}
        finally { setBuffering(false); }
    };

    const [project, setProject] = useState([]);

    const getProject = async (filters = null) => {
        setBuffering(true);
        try {
            let result;
            if (filters) {
                const safe = (val) => (val ? val : "null");
                const url = `${BASE_URL}/dpr/sectionmultiplefilter/${safe(filters.project)}/${safe(filters.section)}/${safe(filters.location)}/${safe(filters.workStage)}/${safe(filters.minLength)}/${safe(filters.maxLength)}/${safe(filters.minCost)}/${safe(filters.maxCost)}/`;
                result = await axios.get(url);
            } else {
                result = await axios.get(`${BASE_URL}/dpr/projectfiltersubconsultant/a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7/`);
            }
            setProject(result.data);
        } catch (err) {}
        finally { setBuffering(false); }
    };

    // ✅ Handlers for filters
    const handleProjectFilter = (filters) => getProjectname(filters);
    const handleSectionFilter = (filters) => getProject(filters);

    useEffect(() => { getProjectname(); }, []);
    useEffect(() => { getProject(); }, []);

    return (
        <>
            <div>
                <div>
                    <Dashboardnavbar name={getSelectedTitle()} url={"Project Management"} />
                </div>

                <div className="content-tabs">
                    <div className='toggle-button-area flex-row justify-between' style={{ padding: "15px 30px" }}>
                        <div className='flex-row justify-between' style={{ width: "100%" }}>
                            <div>
                                <button
                                    className={toggleState === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                    onClick={() => setToggleState(1)}
                                >
                                    Railways Project Details
                                </button>
                                <button
                                    className={toggleState === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                    onClick={() => setToggleState(2)}
                                >
                                    Railways Section Details
                                </button>
                            </div>

                            {toggleState === 1 ?
                                <AddRailwayProject getProjectname={getProjectname} useFor="table" /> :
                                <AddProjectDetails getProject={getProject} project={project} ProjectDetails={projectName} usedFor="Railway" />
                            }
                        </div>
                    </div>

                    <div style={{ padding: "0 30px" }}>

                        {/* ✅ TAB 1 — Railway Project Details */}
                        {toggleState === 1 &&
                            <>
                                <ProjectFilter onApply={handleProjectFilter} hideSector={true} />
                                <RailwaysProject
                                    projectName={projectName}
                                    getProjectname={getProjectname}
                                    getProject={getProject}
                                    buffer={buffer}
                                    hideSector={true}
                                />
                            </>
                        }

                        {/* ✅ TAB 2 — Railway Section Details */}
                        {toggleState === 2 &&
                            <>
                                <SectionFilter onApply={handleSectionFilter} sectionData={project} />
                                <RailwaySections
                                    project={project}
                                    getProject={getProject}
                                    buffer={buffer}
                                    ProjectDetails={projectName}
                                    hideSector={true}
                                />
                            </>
                        }

                    </div>
                </div>
            </div>
        </>
    );
};

export default RailwayPage;